"use client";

import { useEffect, useState } from "react";

import { CardServizio } from "@/components/servizi/catalogo/CardServizio";
import { SERVIZI_CATALOGO, servizioDi, sorteggiaServizi } from "@/lib/sorteggio-servizi";
import { TOTALE_SERVIZI } from "@/lib/serviziPagina";

/** Le card di «Esplora gli altri servizi» a rotazione (19/10/2026).
 *
 *  Le pagine dei servizi e /contatti sono statiche (escono `○` / SSG dal
 *  build), quindi il server non può sorteggiare a ogni visita senza
 *  renderle dinamiche. Il sorteggio lo fa il browser, dopo l'idratazione:
 *  lo stato parte da `iniziali` (la scelta fissa, uguale nell'HTML del
 *  build e nella prima resa del client, quindi niente errore di
 *  idratazione) e un effetto al montaggio lo sostituisce con tre servizi
 *  a caso fra quelli non in `escludi`. È la forma di `HomeCorridorsBand`.
 *
 *  Ogni card porta come `riserva` i testi di tutti i servizi che possono
 *  uscire, invisibili nella stessa cella del testo vero (`CardServizio`):
 *  l'altezza non dipende da quale servizio esce, e il cambio dopo
 *  l'idratazione non sposta la pagina. */
export function AltriServiziARotazione({ iniziali, escludi }: { iniziali: string[]; escludi: string[] }) {
  const [scelti, setScelti] = useState(iniziali);
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect -- voluto: il sorteggio dopo l'idratazione, perché nel render (o sul server di una rotta statica) darebbe un HTML diverso fra build e browser
    setScelti(sorteggiaServizi(iniziali.length, { escludi }));
    // Una volta per montaggio: `iniziali` ed `escludi` sono costanti della pagina.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const fuori = new Set(escludi);
  const riserva = SERVIZI_CATALOGO.filter((s) => !fuori.has(s.slug));
  return (
    <>
      {scelti.flatMap((slug) => {
        const s = servizioDi(slug);
        return s ? [<CardServizio key={slug} s={s} totale={TOTALE_SERVIZI} riserva={riserva} />] : [];
      })}
    </>
  );
}
